import React, { useEffect } from 'react';
import ExternalTimeAgo from 'react-timeago';

import {T} from './I18n';

function TimeAgo({date}) {
  const [, rerender] = React.useState(0);
  const handle = React.createRef();
  const now = new Date();
  const dateTime = typeof date === 'number' ? date : date.getTime();
  const isLessThan1Minute = now.getTime() - dateTime < 60000;

  useEffect(() => {
    handle.current = setTimeout(() => {
      if (isLessThan1Minute) {
        rerender(1);
      }
    }, 61000);

    return () => clearTimeout(handle.current);
  }, [dateTime]);

  if (isLessThan1Minute) {
    return 'just now';
  }

  return <T variable="timeago"><ExternalTimeAgo date={date} /></T>;
}

export default TimeAgo;